import { render, staticRenderFns } from "./AmountLabel.vue?vue&type=template&id=df65c870"
import script from "./AmountLabel.vue?vue&type=script&lang=js"
export * from "./AmountLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports